import { Property } from '@data/models';
import { apiCall, IRequestOptions } from '../axios';

export class PropertyService {
  static getProperty(code?: string, options: IRequestOptions = {}) {
    const url = '/property_info';
    return apiCall(Property)('post', url, { property_code: code }, options);
  }
}
